export default __webpack_public_path__ + "static/media/tokenomicMb2.80670742.png";